import axios from "axios";

const instance = axios.create({
    baseURL: "https://hackernewsclone-9d286-default-rtdb.firebaseio.com"
});

export default instance;
